import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const SaleChannelSelectorModal = ({
  showModal,
  setShowModal,
  saleChannels,
  selectedProducts,
  onConfirmHandler
}) => {

  const [selectedSaleChannel, setSelectedSaleChannel] = useState(null);

  const handleCloseModal = () => {
    setSelectedSaleChannel(null);
    setShowModal(false);
  }


  return <Modal show={showModal} onHide={handleCloseModal} animation={false} centered>
    <Modal.Header>
      <Modal.Title>{I18n.t("js.myCollectionEditPage.saleChannelsModalTitle")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="row d-flex flex-wrap justify-content-center w-100 mx-0">
        {saleChannels.map((sale_channel) =>
          <div className='col-6 col-sm-4 col-md-3  mb-2 p-0 px-1' key={sale_channel.id}>
            <div className="p-2px bg-aig-gradient br-8px h-100" onClick={() => setSelectedSaleChannel(sale_channel)}>
              <div className={`d-flex flex-directions-column justify-content-between ${selectedSaleChannel?.id === sale_channel.id ? 'text-white' : 'bg-white-imp'} br-8px text-center cursor-pointer font-size-18px p-1 h-100`}>
                <div className="d-flex justify-content-center w-100">
                  <img src={sale_channel.thumb_icon_url} className="opacity-1-imp my-2" width="40px" />
                </div>
                {sale_channel.meta_name}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button
        type="button"
        className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized h-40px-imp"
        onClick={handleCloseModal}
      >
        {I18n.t('js.common.cancel').toUpperCase()}
      </button>
      <button
        disabled={!selectedSaleChannel}
        type="button"
        className="btn-standard bg-aig-gradient color-white br-20px pr-2 pl-2 w-120px btn-standard-resized pt-6px-imp h-35px"
        onClick={() => {
          handleCloseModal();
          onConfirmHandler(selectedSaleChannel.id, selectedProducts);
        }}
      >
        {I18n.t('js.common.confirm').toUpperCase()}
      </button>
    </Modal.Footer>
  </Modal>
};

export default SaleChannelSelectorModal;